import React from "react";
import { NavLink } from "react-router-dom";
import companyLogo from "../assets/company_logo.png";
import laptoMetrics from "../assets/Laptop Metrics.png";
import historicalAnalysis from "../assets/analysis.png";
import promoInsights from "../assets/insights.png";
import promoPack from "../assets/promo_pack.png";
import logOut from "../assets/logout.png";

const navLinkDefultStyles = "flex items-center gap-x-3 px-4 py-2";

const activeStyles = `${navLinkDefultStyles} bg-white text-black rounded-md`;
const inActiveStyles = `${navLinkDefultStyles} text-white border border-white rounded-md`;

const Sidebar: React.FC = () => {
  return (
    <div className="hidden md:flex  px-4 w-full md:w-[270px] bg-[#DC0315] z-2 fixed top-0 flex-col gap-y-4 min-h-screen z-20">
      <img
        className="mx-auto mt-8 mb-4"
        width={150}
        height={130}
        src={companyLogo}
        alt="Company Logo"
      />

      <div className="flex flex-col gap-y-8">
        <NavLink
          to={"/dashboard"}
          className={({ isActive }) =>
            isActive ? activeStyles : inActiveStyles
          }
        >
          <img width={37} height={33} src={laptoMetrics} alt="Metrics" />

          <h6>Home</h6>
        </NavLink>

        <NavLink
          to={"/historocal-analysis"}
          className={({ isActive }) =>
            isActive ? activeStyles : inActiveStyles
          }
        >
          <img
            width={37}
            height={33}
            src={historicalAnalysis}
            alt="Historical Analysis"
          />

          <h6>Historical Analysis</h6>
        </NavLink>

        <NavLink
          to={"/promon-insights"}
          className={({ isActive }) =>
            isActive ? activeStyles : inActiveStyles
          }
        >
          <img
            width={30}
            height={26}
            src={promoInsights}
            alt="Promo Insights"
          />

          <h6>Daily Promo Insights</h6>
        </NavLink>
      </div>

      <div className="mt-5 mx-auto">
        <img width={170} height={130} src={promoPack} alt="Promo Pack" />
      </div>

      <div className="mt-5">
        <div className="flex items-center gap-x-3 px-4 py-2 text-white cursor-pointer">
          <img width={30} height={26} src={logOut} alt="Logout" />

          <h6>Log Out</h6>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
